module.exports = __webpack_public_path__ + "img/glit.4c7b24b1.jpg";